import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { useTranslate } from "ra-core";
import { TopToolbar } from "../../layout/TopToolbar";
import { AccountBalanceBadge } from "./AccountBalanceBadge";
import type { Account } from "../../types";

export const AccountList = () => (
  <List
    sort={{ field: "name", order: "ASC" }}
    actions={<AccountActions />}
    pagination={<ListPagination rowsPerPageOptions={[10, 25, 50]} />}
    filter={{ "archived_at@is": null }}
  >
    <DataTable<Account> rowClick="edit">
      <DataTable.Col source="name" />
      <DataTable.Col source="type" render={(r) => <AccountTypeCell type={r.type} />} />
      <DataTable.Col source="currency" />
      <DataTable.Col
        source="initial_balance"
        render={(r) => Number(r.initial_balance).toLocaleString("ru-RU")}
      />
      <DataTable.Col
        label="resources.accounts.fields.current_balance"
        source="id"
        render={(r) => <AccountBalanceBadge accountId={r.id} />}
      />
    </DataTable>
  </List>
);

const AccountTypeCell = ({ type }: { type: string }) => {
  const translate = useTranslate();
  return <>{translate(`resources.accounts.types.${type}`, { _: type })}</>;
};

const AccountActions = () => (
  <TopToolbar>
    <ExportButton />
    <CreateButton label="resources.accounts.action.new" />
  </TopToolbar>
);
